import React from 'react';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';
import tableStyles from '../../../components/tables/table.module.scss';
import styles from './UserActivityLogsTable.module.scss';

export const userActivityEventTypeLabels = {
  new_user_registered: 'Registrovan novi korisnik',
  existing_user_registered_and_matched: 'Registrovan postojeći korisnik',
  user_data_changed: 'Izmena podataka korisnika',
};

const formatDateTime = (value) => {
  if (!value) return '-';

  const parsedDate = dayjs(value);
  return parsedDate.isValid() ? parsedDate.format('DD.MM.YYYY. HH:mm') : value;
};

const UserActivityLogsTable = ({
  data = [],
  emptyState = {
    icon: '/assets/icons/no-users.svg',
    title: 'Trenutno nema korisničkih izmena',
  },
}) => {
  return (
    <div className={styles.tableWrapper}>
      <table
        style={{ width: '100%', minWidth: 980 }}
        className={styles.activityTable}
      >
        <colgroup>
          <col style={{ width: '16%' }} />
          <col style={{ width: '22%' }} />
          <col style={{ width: '14%' }} />
          <col style={{ width: '48%' }} />
        </colgroup>
        <thead>
          <tr>
            <th>Datum</th>
            <th>Tip aktivnosti</th>
            <th>LBO</th>
            <th>Opis</th>
          </tr>
        </thead>
        <tbody>
          {data.map((activityLog, index) => {
            const rowId =
              activityLog?._id ||
              `${activityLog?.changedAt || activityLog?.createdAt || 'log'}-${index}`;

            return (
              <tr key={rowId}>
                <td>
                  <span className={styles.nowrapText}>
                    {formatDateTime(
                      activityLog?.changedAt || activityLog?.createdAt
                    )}
                  </span>
                </td>
                <td>
                  <span className={`${styles.wrapText} ${styles.eventType}`}>
                    {userActivityEventTypeLabels[activityLog?.eventType] ||
                      activityLog?.eventType ||
                      '-'}
                  </span>
                </td>
                <td>
                  <span className={styles.wrapText}>
                    {activityLog?.lbo || '-'}
                  </span>
                </td>
                <td>
                  <span className={`${styles.wrapText} ${styles.messageText}`}>
                    {activityLog?.message || '-'}
                  </span>
                </td>
              </tr>
            );
          })}
          {data.length === 0 && (
            <tr>
              <td colSpan={4} style={{ textAlign: 'center', padding: 8 }}>
                <div className={tableStyles.noData}>
                  <img src={emptyState.icon} alt="Nema podataka" />
                  <h3>{emptyState.title}</h3>
                </div>
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

UserActivityLogsTable.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  emptyState: PropTypes.shape({
    icon: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
  }),
};

export default UserActivityLogsTable;
